import React from 'react'
import { Fade } from "react-awesome-reveal";
/* eslint-disable no-unused-vars */

const features = [
    {
        icon: (
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2V6M12 18V22M6 12H2M22 12H18M19.07 4.93L16.24 7.76M7.76 16.24L4.93 19.07M19.07 19.07L16.24 16.24M7.76 7.76L4.93 4.93" stroke="url(#grad1)" strokeWidth="2" strokeLinecap="round"/>
                <circle cx="12" cy="12" r="4" stroke="url(#grad1)" strokeWidth="2"/>
                <defs>
                    <linearGradient id="grad1" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#3b82f6"/>
                        <stop offset="1" stopColor="#1d4ed8"/>
                    </linearGradient>
                </defs>
            </svg>
        ),
        title: 'Cost Visibility',
        description: 'Get real-time insights into billing across all your integrated services. Track spending patterns and identify optimization opportunities.',
    },
    {
        icon: (
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15M9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5M12 12H15M12 16H15M9 12H9.01M9 16H9.01" stroke="url(#grad2)" strokeWidth="2" strokeLinecap="round"/>
                <defs>
                    <linearGradient id="grad2" x1="5" y1="3" x2="19" y2="21" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#3b82f6"/>
                        <stop offset="1" stopColor="#1d4ed8"/>
                    </linearGradient>
                </defs>
            </svg>
        ),
        title: 'Review & Manage',
        description: 'Review your vendors, contracts, and subscriptions in one unified dashboard. Never miss a renewal or overpay again.',
    },
    {
        icon: (
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 10V3L4 14H11V21L20 10H13Z" stroke="url(#grad3)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <defs>
                    <linearGradient id="grad3" x1="4" y1="3" x2="20" y2="21" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#3b82f6"/>
                        <stop offset="1" stopColor="#1d4ed8"/>
                    </linearGradient>
                </defs>
            </svg>
        ),
        title: 'Coming Soon',
        description: 'AI-powered cost savings insights across cloud spend. Contract parsing for comprehensive spend tracking beyond integrated providers.',
    },
];

const FeaturesService = () => {
    return (
        <section id="features" className="features-modern">
            {/* Background decorative elements */}
            <div style={{
                position: 'absolute',
                top: '10%',
                right: '5%',
                width: '400px',
                height: '400px',
                background: 'radial-gradient(circle, rgba(59, 130, 246, 0.08) 0%, transparent 70%)',
                borderRadius: '50%',
                pointerEvents: 'none'
            }}></div>
            <div style={{
                position: 'absolute',
                bottom: '10%',
                left: '5%',
                width: '300px',
                height: '300px',
                background: 'radial-gradient(circle, rgba(29, 78, 216, 0.08) 0%, transparent 70%)',
                borderRadius: '50%',
                pointerEvents: 'none'
            }}></div>

            <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                {/* Section Header */}
                <div className="section-header-modern">
                    <Fade direction="down" triggerOnce={true} duration={800}>
                        <span className="section-badge">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            Features
                        </span>
                    </Fade>
                    <Fade direction="down" triggerOnce={true} duration={1000} delay={100}>
                        <h2 className="section-title">Why SAAS Watch?</h2>
                    </Fade>
                    <Fade direction="down" triggerOnce={true} duration={1000} delay={200}>
                        <p className="section-subtitle">
                            Everything you need to take control of your SaaS subscriptions and optimize cloud spending.
                        </p>
                    </Fade>
                </div>

                {/* Feature Cards */}
                <div className="row">
                    {features.map((feature, index) => (
                        <div key={index} className="col-12 col-md-6 col-lg-4 mb-4">
                            <Fade direction="up" triggerOnce={true} duration={1000} delay={index * 150}>
                                <div className="feature-card-modern hover-lift">
                                    <div className="feature-icon">
                                        {feature.icon}
                                    </div>
                                    <h3 className="feature-title">{feature.title}</h3>
                                    <p className="feature-desc">{feature.description}</p>
                                </div>
                            </Fade>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default FeaturesService;
